(function () {
  'use strict';

  var config = window.ServiceFeeConfig || {};
  var VARIANT_ID = String(config.variantId || '');
  var FEE_PERCENTAGE = config.percentage || 3;
  var FEE_PROPERTY_KEY = '_fee';
  var FEE_PROPERTY_VALUE = '1';

  var UPDATING = false;
  var PENDING_SYNC = false;
  var DEBOUNCE_TIMER = null;
  var CHECKOUT_INITIATED = false;

  if (!VARIANT_ID) {
    console.warn('[CreditCardFee] No variantId in window.ServiceFeeConfig.');
    return;
  }

  var CART_PATHS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function onCartPage() {
    return /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  function isCartWriteUrl(url) {
    if (typeof url !== 'string') return false;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin) return false;
      return CART_PATHS.some(function (p) { return parsed.pathname.startsWith(p); });
    } catch (e) {
      return false;
    }
  }

  var nativeFetch = window.fetch.bind(window);

  function cartFetch(url, opts) {
    if (CHECKOUT_INITIATED) return Promise.reject(new Error('Checkout in progress'));
    return nativeFetch(url, opts).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (body) {
          var msg = (body && body.description) || (body && body.message) || r.statusText;
          throw new Error('[CreditCardFee] ' + url + ' failed: ' + msg);
        });
      }
      return r.json();
    });
  }

  function fetchCart() {
    return cartFetch('/cart.js');
  }

  function isFeeLineItem(item) {
    if (String(item.variant_id) !== VARIANT_ID) return false;
    var props = item.properties;
    if (!props) return false;
    return props[FEE_PROPERTY_KEY] === FEE_PROPERTY_VALUE;
  }

  function getSubtotalExcludingFee(cart) {
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isFeeLineItem(cart.items[i])) {
        total += cart.items[i].line_price;
      }
    }
    return total;
  }

  function getFeeItem(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isFeeLineItem(cart.items[i])) return cart.items[i];
    }
    return null;
  }

  function calcFeeQty(subtotalCents) {
    return Math.max(1, Math.round(subtotalCents * FEE_PERCENTAGE / 100));
  }

  function setFeeQty(feeItemKey, qty) {
    var updates = {};
    updates[feeItemKey] = qty;
    return cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function addFeeToCart(qty) {
    return cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(VARIANT_ID), quantity: qty, properties: { _fee: '1' } }]
      })
    });
  }

  function removeFee(feeItemKey) {
    var updates = {};
    updates[feeItemKey] = 0;
    return cartFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
  }

  function syncFee() {
    if (UPDATING || CHECKOUT_INITIATED) { PENDING_SYNC = !CHECKOUT_INITIATED; return; }
    UPDATING = true;
    PENDING_SYNC = false;

    fetchCart().then(function (cart) {
      if (CHECKOUT_INITIATED) { UPDATING = false; return; }

      var subtotal = getSubtotalExcludingFee(cart);
      var feeItem = getFeeItem(cart);

      if (subtotal <= 0) {
        if (feeItem) return removeFee(feeItem.key).then(function () { done(true); });
        return done(false);
      }

      var targetQty = calcFeeQty(subtotal);

      if (!feeItem) {
        return addFeeToCart(targetQty).then(function () { done(true); });
      }

      if (feeItem.quantity !== targetQty) {
        return setFeeQty(feeItem.key, targetQty).then(function () { done(true); });
      }

      done(false);
    }).catch(function (err) {
      if (!CHECKOUT_INITIATED) console.error('[CreditCardFee]', err);
      UPDATING = false;
      if (PENDING_SYNC && !CHECKOUT_INITIATED) { PENDING_SYNC = false; scheduleSync(); }
    });
  }

  function done(cartChanged) {
    UPDATING = false;
    if (CHECKOUT_INITIATED) return;
    if (cartChanged) {
      refreshCartUI();
    } else {
      applyFeeDOM();
    }
    if (PENDING_SYNC) { PENDING_SYNC = false; scheduleSync(); }
  }

  function scheduleSync() {
    if (CHECKOUT_INITIATED) return;
    clearTimeout(DEBOUNCE_TIMER);
    DEBOUNCE_TIMER = setTimeout(syncFee, 300);
  }

  // ── Checkout guard ────────────────────────────────────────────────────────
  // Aggressively block ALL cart modifications once the user intends to check out.

  function lockForCheckout() {
    if (CHECKOUT_INITIATED) return;
    CHECKOUT_INITIATED = true;
    UPDATING = true;
    PENDING_SYNC = false;
    clearTimeout(DEBOUNCE_TIMER);
  }

  // Catch checkout button clicks EARLY (capture phase)
  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target) return;
    var btn = target.closest
      ? target.closest('[name="checkout"], [type="submit"][value*="heckout"], a[href*="/checkout"], button[name="checkout"]')
      : null;
    if (btn) lockForCheckout();
  }, true);

  // Catch checkout form submissions
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/checkout') !== -1) {
      lockForCheckout();
    }
    if (form && form.querySelector && form.querySelector('[name="checkout"]')) {
      lockForCheckout();
    }
  }, true);

  // Final safety net: beforeunload
  window.addEventListener('beforeunload', function () {
    lockForCheckout();
  });

  // ── Cart UI refresh ───────────────────────────────────────────────────────

  function refreshCartUI() {
    if (CHECKOUT_INITIATED) return;

    var isCart = onCartPage();

    // Try sections API first, then fall back to page reload
    var allSectionIds = isCart
      ? ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble',
         'cart-items', 'cart-footer', 'header']
      : ['cart-drawer', 'cart-icon-bubble', 'cart-notification',
         'header', 'mini-cart'];

    // Only request sections that actually exist on the page
    var validSections = allSectionIds.filter(function (id) {
      return document.getElementById('shopify-section-' + id);
    });

    if (validSections.length === 0) {
      // No matching sections found - just reload the page
      if (isCart) {
        window.location.reload();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    nativeFetch(root + '?sections=' + validSections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (CHECKOUT_INITIATED) return;
        var updated = false;
        validSections.forEach(function (id) {
          if (!data[id]) return;
          var wrapper = document.getElementById('shopify-section-' + id);
          if (!wrapper) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = data[id];
          var inner = tmp.querySelector('[id^="shopify-section-"]');
          wrapper.innerHTML = inner ? inner.innerHTML : data[id];
          wrapper.querySelectorAll('cart-drawer, cart-items, cart-drawer-items').forEach(function (el) {
            var clone = el.cloneNode(true);
            el.parentNode.replaceChild(clone, el);
          });
          updated = true;
        });

        if (!updated && isCart) {
          window.location.reload();
          return;
        }

        [100, 400, 800].forEach(function (ms) { setTimeout(applyFeeDOM, ms); });
      })
      .catch(function () {
        if (CHECKOUT_INITIATED) return;
        if (isCart) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        }
      });
  }

  // ── DOM tweaks ────────────────────────────────────────────────────────────

  function injectFeeStyles() {
    if (document.getElementById('credit-card-fee-styles')) return;
    var style = document.createElement('style');
    style.id = 'credit-card-fee-styles';
    style.textContent = '.fee-line-item { display: none !important; }';
    document.head.appendChild(style);
  }

  function applyFeeDOM() {
    var cartRows = document.querySelectorAll('.cart-item, [data-cart-item], tr[class*="line-item"]');
    var feeRow = null;

    cartRows.forEach(function (row) {
      var isFeeRow = false;

      if (row.querySelector('a[href*="/products/credit-card-fee"]')) isFeeRow = true;
      if (!isFeeRow && row.querySelector('a[href*="/products/service-fee"]')) isFeeRow = true;

      if (!isFeeRow) {
        row.querySelectorAll('input[name*="id"], input[data-quantity-variant-id]').forEach(function (inp) {
          if (String(inp.value) === VARIANT_ID) isFeeRow = true;
        });
      }

      if (!isFeeRow) {
        var text = row.textContent || '';
        if (text.indexOf('Credit Card Fee') !== -1 || text.indexOf('credit card fee') !== -1) {
          isFeeRow = true;
        }
      }

      if (!isFeeRow) return;

      feeRow = row;
      row.classList.add('fee-line-item');

      ['.quantity', 'quantity-popover', '.cart-item__quantity',
        '.cart-item__quantity-wrapper', '.cart-item__quantity-subtract',
        '.cart-item__quantity-add', 'quantity-input'].forEach(function (sel) {
        row.querySelectorAll(sel).forEach(function (el) {
          el.style.setProperty('display', 'none', 'important');
        });
      });
    });
  }

  // ── Interception ──────────────────────────────────────────────────────────

  var _origFetch = window.fetch;
  window.fetch = function (url, opts) {
    var result = _origFetch.apply(this, arguments);
    if (!UPDATING && !CHECKOUT_INITIATED && isCartWriteUrl(url)) {
      result.then(function () { scheduleSync(); }).catch(function () {});
    }
    return result;
  };

  var _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (!UPDATING && !CHECKOUT_INITIATED && isCartWriteUrl(url)) {
      this.addEventListener('load', function () { scheduleSync(); });
    }
    return _origOpen.apply(this, arguments);
  };

  ['cart:refresh', 'cart:updated', 'cart-changed', 'theme:cart:updated'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      if (!UPDATING && !CHECKOUT_INITIATED) scheduleSync();
    });
  });

  // ── Init ──────────────────────────────────────────────────────────────────

  function init() {
    injectFeeStyles();
    syncFee();
    setTimeout(applyFeeDOM, 600);
    setTimeout(applyFeeDOM, 1500);
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      CHECKOUT_INITIATED = false;
      UPDATING = false;
      PENDING_SYNC = false;
      syncFee();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();